import { render, staticRenderFns } from "./HorizontalImageWall.vue?vue&type=template&id=dd4fca36&scoped=true"
import script from "./HorizontalImageWall.vue?vue&type=script&lang=js"
export * from "./HorizontalImageWall.vue?vue&type=script&lang=js"
import style0 from "./HorizontalImageWall.vue?vue&type=style&index=0&id=dd4fca36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4fca36",
  null
  
)

export default component.exports